import type { ViewMode } from '../../types';

interface NavigationProps {
  currentView: ViewMode;
  onViewChange: (view: ViewMode) => void;
}

export function Navigation({ currentView, onViewChange }: NavigationProps) {
  const navItems: Array<{ view: ViewMode; label: string; icon: string }> = [
    {
      view: 'grid',
      label: 'Gallery',
      icon: 'M4 6h6v6H4zM14 6h6v6h-6zM4 14h6v6H4zM14 14h6v6h-6z',
    },
    {
      view: 'feed',
      label: 'Feed',
      icon: 'M4 6h16v2H4zM4 11h16v2H4zM4 16h16v2H4z',
    },
  ];

  return (
    <nav class="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 safe-bottom z-40">
      <div class="flex justify-around py-2">
        {navItems.map(({ view, label, icon }) => (
          <button
            key={view}
            onClick={() => onViewChange(view)}
            class={`touch-target flex flex-col items-center justify-center transition-colors ${
              currentView === view ? 'text-soft-blue' : 'text-gray-400'
            }`}
            aria-label={`Switch to ${label} view`}
            aria-current={currentView === view ? 'page' : undefined}
          >
            <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
              <path d={icon} />
            </svg>
            <span class="text-xs mt-1">{label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
}